import script from "./ServerServicesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ServerServicesTab.vue?vue&type=script&setup=true&lang=js"

import "./ServerServicesTab.vue?vue&type=style&index=0&id=6f82a9a5&lang=scss"

const __exports__ = script;

export default __exports__